import { IPncpBiddingDetailResponse, IPncpPurchaseItemResponse } from "../../../model/base/response/pncp-bidding-detail-response";

export enum ACTION_TYPES {
    LOAD_START = 'LOAD_START',
    LOAD_SUCCESS = 'LOAD_SUCCESS',
    LOAD_ERROR = 'LOAD_ERROR',
    LOAD_ITEMS_START = 'LOAD_ITEMS_START',
    LOAD_ITEMS_SUCCESS = 'LOAD_ITEMS_SUCCESS',
    LOAD_ITEMS_ERROR = 'LOAD_ITEMS_ERROR'
}

export interface IPncpBiddingDetailState {
    biddingDetail: IPncpBiddingDetailResponse | null;
    loading: boolean;
    error: string | null;
    items: IPncpPurchaseItemResponse[];
    itemsPage: number;
    hasMoreItems: boolean;
    loadingItems: boolean;
    itemsError: string | null;
}

export const initialState: IPncpBiddingDetailState = {
    biddingDetail: null,
    loading: true,
    error: null,
    items: [],
    itemsPage: 0,
    hasMoreItems: false,
    loadingItems: false,
    itemsError: null
};

export type Action =
    | { type: ACTION_TYPES.LOAD_START }
    | { type: ACTION_TYPES.LOAD_SUCCESS; payload: IPncpBiddingDetailResponse }
    | { type: ACTION_TYPES.LOAD_ERROR; payload: string }
    | { type: ACTION_TYPES.LOAD_ITEMS_START }
    | { type: ACTION_TYPES.LOAD_ITEMS_SUCCESS; payload: { items: IPncpPurchaseItemResponse[]; page: number; hasMore: boolean } }
    | { type: ACTION_TYPES.LOAD_ITEMS_ERROR; payload: string };

export const pncpBiddingDetailReducer = (state: IPncpBiddingDetailState, action: Action): IPncpBiddingDetailState => {
    switch (action.type) {
        case ACTION_TYPES.LOAD_START:
            return { ...state, biddingDetail: null, loading: true, error: null };
        case ACTION_TYPES.LOAD_SUCCESS:
            return { ...state, biddingDetail: action.payload, loading: false };
        case ACTION_TYPES.LOAD_ERROR:
            return { ...state, loading: false, error: action.payload };
        case ACTION_TYPES.LOAD_ITEMS_START:
            return { ...state, loadingItems: true, itemsError: null };
        case ACTION_TYPES.LOAD_ITEMS_SUCCESS:
            return {
                ...state,
                loadingItems: false,
                items: action.payload.page === 1 ? action.payload.items : [...state.items, ...action.payload.items],
                itemsPage: action.payload.page,
                hasMoreItems: action.payload.hasMore
            };
        case ACTION_TYPES.LOAD_ITEMS_ERROR:
            return { ...state, loadingItems: false, itemsError: action.payload };
        default:
            throw new Error(`Unhandled action type`);
    }
};
